<template>
    <div class="online_success no-trans" v-loading="loading">
        <div class="online_success_box">
            <div class="title_box">
                <div class="title_text">提交成功</div>
                <div class="borders"></div>
            </div>
            <div class="img_box">
                <img src="@/assets/img/index/home/success.png" alt="">
            </div>
            <div class="success_text">提交成功</div>
            <div class="success_text2">您耐心等候，审核通过后，在个人中心-消息中查看</div>
            <div class="btn_flex">
                <div class="btns1" @click="handle_detial()">查看详情</div>
                <div class="btns2" @click="handle_home()">返回首页</div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'




export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            type_end:1,//1成功
        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    methods: {
        handle_detial(){
            this.$router.push({
                path:'/user_order/order_detial',
                query:{
                    id:this.$route.query.order_id
                }
            })
        },
        //返回首页
        handle_home(){
            this.$router.push({
                path:'/home'
            })
        },


    },

}
</script>
<style scoped lang="less">
.online_success {
   width: 100%;
   height: 600px;
   background-color: #FFFFFF;
   .online_success_box{
        width: 1440px;
        height: 100%;
        padding-top: 30px;
        margin: auto;
        .title_box{
            .title_text{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 24px;
                color: #333333;
            }
            .borders{
                width: 100%;
                height: 1px;
                background: #D5D8DE;
                border-radius: 0px 0px 0px 0px;
                margin-top: 16px;
            }
        }
        .img_box{
            width: 80px;
            height: 80px;
            margin: auto;
            margin-top: 64px;
            img{
                width: 80px;
                height: 80px;
            }
        }
        .success_text{
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #000000;
            text-align: center;
            padding-top: 24px;
        }
        .success_text2{
            text-align: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding-top: 18px;
        }
        .btn_flex{
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 33px;
            .btns1{
                width: 128px;
                height: 40px;
                background: #377CFD;
                text-align: center;
                line-height: 40px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                border-radius: 8px;
                cursor: pointer;
            }
            .btns2{
                width: 128px;
                height: 40px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #377CFD;
                line-height: 40px;
                text-align: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #377CFD;
                cursor: pointer;
                margin-left: 24px;
                border-radius: 8px;
            }
        }
   }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .online_success.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        min-height: 0;
        height: auto;
    }
    .online_success.no-trans .online_success_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding-top: 16px;
        margin: auto;
    }
    .online_success.no-trans .online_success_box .title_box .title_text {
        font-size: 24px;
    }
    .online_success.no-trans .online_success_box .title_box .borders {
        height: 1px;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
    }
    .online_success.no-trans .online_success_box .img_box {
        width: 80px;
        height: 80px;
        margin: auto;
        margin-top: 16px;
    }
    .online_success.no-trans .online_success_box .img_box img {
        width: 80px;
        height: 80px;
    }
    .online_success.no-trans .online_success_box .success_text {
        font-size: 24px;
        padding-top: 16px;
    }
    .online_success.no-trans .online_success_box .success_text2 {
        font-size: 14px;
        padding-top: 16px;
    }
    .online_success.no-trans .online_success_box .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .online_success.no-trans .online_success_box .btn_flex .btns1 {
        width: 128px;
        height: auto;
        line-height: 1.6;
        font-size: 14px;
        border-radius: 8px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .online_success.no-trans .online_success_box .btn_flex .btns2 {
        width: 128px;
        height: auto;
        border-radius: 8px;
        line-height: 1.6;
        font-size: 14px;
        margin-left: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
